import { MainLayoutContent } from "components/layouts/MainLayoutContent";
import { AppRouteType } from "navigation/registryRoutes";
import slugs from "navigation/slugs";

import React from "react";
const AgePage = React.lazy(() => import("../page"));

const routes: AppRouteType[] = [
  {
    path: slugs.age,
    component: AgePage,
    container: MainLayoutContent,
    isAuthNeeded: true,
  },
];

export default routes;
